import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './Header.css';
import Link from '../Link';
import LogoSvgFull from './LogoSvgFull';
import Logo from './img/logowhite.png';

import history from '../../history';
import { smoothScroll } from '../../utils';
import getPlatformUrl from '../../utils/login';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: 0,
      isOpenedPanel: false,
      scrollPosition: 0,
    };
  }

  componentDidMount() {
    this.updateDimensions();
    this.uppdateScroll();
  }

  componentDidUpdate() {
    window.addEventListener('resize', this.updatedDimensions);
    window.addEventListener('scroll', this.uppdateScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('scroll', this.uppdateScroll);
  }

  uppdateScroll = () => {
    this.setState({
      scrollPosition: window.scrollY,
    });
  };

  scrollToNews = () => {
    smoothScroll.scrollTo('newsHere');
  };

  updateDimensions = () => {
    this.setState({
      windowWidth: window.innerWidth,
    });
  };

  clickSignIn = () => {
    history.push('/sign-in');
    this.setState({ isOpenedPanel: false });
  };

  clickLogin = () => {
    history.push('/sign-in');
    this.setState({ isOpenedPanel: false });
  };

  navClick = to => {
    const nav = () => {
      if (window.location.pathname === '/') {
        smoothScroll.scrollTo(to);
      } else {
        history.push(`/#${to}`);
      }
    };

    this.setState(
      {
        isOpenedPanel: false,
      },
      nav,
    );
  };

  goTo = to => {
    const nav = () => {
      this.props.logoutUser();
      history.push(to);
    };

    this.setState(
      {
        isOpenedPanel: false,
      },
      nav,
    );
  };

  togglePanel = () => {
    this.setState(prevState => ({
      isOpenedPanel: !prevState.isOpenedPanel,
    }));
  };

  handleGoToPlatform = () => {
    const { user } = this.props;
    const redirectUrl = getPlatformUrl({
      organizationSubdomain: user.subdomain_url,
      websiteHost: window.location.host,
    });
    window.location.replace(redirectUrl);
  };

  render() {
    const { isLogin, windowWidth, isOpenedPanel, scrollPosition } = this.state;

    const {
      isLoggedIn,
      user,
      isCookieConsentGiven,
      headerBackground,
    } = this.props;

    let headerStyle = {
      backgroundColor: 'transparent',
      boxShadow: '0 0 0 0 #fff',
    };
    let textColor = '#fff';
    let buttonTextColor = '#5d4ea2';

    if (headerBackground === 'white' || scrollPosition > 100) {
      headerStyle = {
        backgroundColor: '#fff',
        boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.12)',
      };
      textColor = '#5d4ea2';
      buttonTextColor = '#fff';
    }

    return (
      <div
        className={s.container}
        style={{
          backgroundColor: scrollPosition < 100 ? 'transparent' : '#1a1a24',
          boxShadow:
            scrollPosition < 100
              ? '0 0 0 0 #fff'
              : '0 4px 10px 0 rgba(0, 0, 0, 0.12)',
        }}
      >
        <Link className={s.brand} onClick={() => this.navClick('top')}>
        { /* <LogoSvgFull className={s.logoSvg} brandColor={textColor} /> */}
        <img src={Logo} style={{width:150}} />
        </Link>
        {windowWidth > 800 && (
          <div className={s.navigation}>
            <div className={s.pageLinks}>
            {/*  <a
                // href="#services"
                onClick={() => this.navClick('services')}
                style={{
                  color: textColor,
                }}
              >
                Product
              </a>
              <a
                onClick={() => this.navClick('team')}
                style={{
                  color: textColor,
                }}
              >
                About us
              </a>
              <a
                href="https://cutshort.io/company/spotmentor-technologies?career_page=true"
                target="_blank"
                style={{
                  color: textColor,
                }}
              >
                Join us
              </a> */}
              <div className={s.buttons}>
                {!this.props.isLoggedIn && (
                  <a
                    onClick={this.clickSignIn}

                  >
                    Login
                  </a>
                )}
                {false && !this.props.isLoggedIn && (
                  <a
                    onClick={this.clickLogin}

                  >
                    Sign In
                  </a>
                )}
                {isLoggedIn && user.subdomain_url && (
                  <button
                    onClick={
                      isCookieConsentGiven ? this.handleGoToPlatform : () => {}
                    }
                    style={{
                      color: buttonTextColor,
                      backgroundColor: isCookieConsentGiven
                        ? textColor
                        : '#777',
                      cursor: isCookieConsentGiven ? 'pointer' : 'no-drop',
                    }}
                    disabled={!isCookieConsentGiven}
                  >
                    Go to Platform
                  </button>
                )}
                {this.props.isLoggedIn && (
                  <a
                    onClick={() => this.goTo('/logout')}
                    style={{
                      color: textColor,
                    }}
                  >
                    <i className="fa fa-power-off" />
                  </a>
                )}
              </div>
            </div>
          </div>
        )}
        {windowWidth <= 800 && (
          <button
            onClick={this.togglePanel}
            className={cx(s.button, { [s.close]: isOpenedPanel })}
          >
            <span className={s.hamburger} />
          </button>
        )}
        {windowWidth <= 800 && isOpenedPanel && (
          <div className={s.sideNavPanel}>
            <div
              ref={c => {
                this.sidePanel = c;
              }}
              className={s.sideNavOverlay}
              // style={{ transform: isOpenedPanel ? 'scale(1)' : 'scale(0)' }}
            />
            <div className={s.smallPageLinks}>
              <a onClick={() => this.navClick('services')}> Product </a>
              <a onClick={() => this.navClick('team')}> About us </a>
              <a
                href="https://cutshort.io/company/spotmentor-technologies?career_page=true"
                target="_blank"
              >
                {' '}
                Join us{' '}
              </a>
              <a onClick={() => history.push('/blog')}> Blogs </a>
            </div>
            <div className={s.smallButtons}>
              {!this.props.isLoggedIn && (
                <a onClick={this.clickLogin}> Sign In </a>
              )}
              {isLoggedIn && user.subdomain_url && (
                  <a
                    onClick={
                      isCookieConsentGiven ? this.handleGoToPlatform : () => {}
                    }
                  >
                    {' '}
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <i className="fa fa-laptop" />
                      Go to Platform{' '}
                    </div>
                  </a>
                )}
              {this.props.isLoggedIn && (
                <a
                  onClick={() => this.goTo('/logout')}
                  style={{ display: 'flex' }}
                >
                  <i className="fa fa-power-off" />
                  Logout
                </a>
              )}
            { /* <button onClick={() => this.goTo('/demo')}>
                {' '}
                Schedule demo{' '}
              </button> */}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(s)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js